import { Fragment } from "react";
import "./live_web_chat_feature.scss";

import LoaderPopUp from "../../../../components/loader/loader";
///////////////////Desktop
import LeftSideBarComponent from "../../structure_components/desktop_screens/left_sideBar_component/left_sideBar_component";
import HeaderComponent from "../../structure_components/desktop_screens/header_component/header_component";

///////Mobile////////////////////
import MobileLeftSideBarComponent from "../../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";
import MobileHeaderComponent from "../../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import MobileRightSideBarComponent from "../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";

import LiveWebChatFeatureContentComponent from "./live_web_chat_feature_content_component/live_web_chat_feature_content_component";

//Redux
import { connect } from "react-redux";

const LiveWebChatFeature = (props) => {
  let { history, location, loader, userData, userPreference } = props;

  const isMob = () => {
    if (window.innerWidth <= 480) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <Fragment>
      <div className="live_web_chat_feature_wrapper">
        <div className="live_web_chat_feature_inner_wrapper">
          {isMob() ? (
            /////for Mobile Screens////////////////////
            <Fragment>
              <MobileLeftSideBarComponent />
              <MobileHeaderComponent
                userPreference={userPreference}
                userData={userData}
              />
              <MobileRightSideBarComponent history={history} />
              <LiveWebChatFeatureContentComponent
                history={history}
                location={location}
              />
            </Fragment>
          ) : (
            /////for Screens greater than Mobile Screens////////////////////
            <Fragment>
              <div className="live_web_chat_feature_left_wrapper">
                <LeftSideBarComponent />
              </div>
              <div className="live_web_chat_feature_right_wrapper">
                <HeaderComponent history={history} />
                <LiveWebChatFeatureContentComponent
                  history={history}
                  location={location}
                />
              </div>
            </Fragment>
          )}
        </div>
      </div>
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps)(LiveWebChatFeature);
